import { c as _c } from "react/compiler-runtime";
function MemePageSkeletonBlock(t0) {
  const $ = _c(2);
  const {
    className
  } = t0;
  const t1 = `tw-animate-pulse tw-rounded tw-bg-iron-800/50 ${className}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div aria-hidden="true" className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
const DETAILS_SKELETON_ITEMS = ["mint-price", "metadata", "floor-price", "market-cap", "highest-offer", "marketplaces"] as const;
const TAB_SKELETON_ITEMS = ["live", "your-cards", "collectors", "history"] as const;
export function MemePageTitleSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-mb-0 tw-flex tw-min-w-0 tw-flex-wrap tw-items-baseline tw-gap-x-2 tw-gap-y-1 md:tw-flex-nowrap md:tw-gap-x-0"><MemePageSkeletonBlock className="tw-h-7 tw-w-20 sm:tw-h-8 sm:tw-w-24" /><span aria-hidden="true" className="tw-mx-3 tw-h-5 tw-w-px tw-self-center tw-bg-white/[0.16] sm:tw-h-6" /><MemePageSkeletonBlock className="tw-h-7 tw-w-48 tw-max-w-[60vw] sm:tw-h-8 sm:tw-w-72 md:tw-max-w-sm" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function MemePageNavigationSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true" className="tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-solid tw-border-white/5 tw-bg-iron-950 tw-px-2 tw-py-1.5"><MemePageSkeletonBlock className="tw-size-8 tw-rounded-md" /><MemePageSkeletonBlock className="tw-h-5 tw-w-16" /><MemePageSkeletonBlock className="tw-size-8 tw-rounded-md" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function MemePageSkeleton() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div><div className="tw-relative tw-w-full tw-overflow-hidden"><div className="tw-relative tw-h-96 tw-w-full tw-animate-pulse tw-bg-iron-800/50 sm:tw-h-[520px] lg:tw-h-[650px]" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MemePageSkeletonBlock className="tw-mb-2 tw-h-4 tw-w-24" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div>{t1}<div className="tw-flex tw-items-center tw-gap-2.5"><MemePageSkeletonBlock className="tw-size-8 tw-rounded-full" /><MemePageSkeletonBlock className="tw-h-5 tw-w-32" /></div></div>;
    t3 = <div><MemePageSkeletonBlock className="tw-mb-2 tw-h-4 tw-w-20" /><MemePageSkeletonBlock className="tw-h-5 tw-w-44" /></div>;
    t4 = <MemePageSkeletonBlock className="tw-mb-4 tw-h-4 tw-w-28" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-mb-6 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[minmax(0,11fr)_minmax(0,9fr)] lg:tw-gap-x-10 xl:tw-gap-x-16">{t0}<div className="tw-pt-6 md:tw-pt-8"><div className="tw-flex tw-flex-col tw-gap-8">{t2}{t3}<div>{t4}<div className="tw-grid tw-grid-cols-1 tw-gap-x-8 tw-gap-y-5 sm:tw-grid-cols-2">{DETAILS_SKELETON_ITEMS.map(_temp)}</div><MemePageSkeletonBlock className="tw-mt-6 tw-h-10 tw-w-44 tw-rounded-md" /></div></div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-mb-6 tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-iron-700"><div className="-tw-mb-px tw-flex tw-gap-x-4">{TAB_SKELETON_ITEMS.map(_temp2)}</div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div aria-hidden="true">{t5}{t6}<div className="tw-space-y-3 tw-pb-3"><MemePageSkeletonBlock className="tw-h-4 tw-w-full tw-max-w-3xl" /><MemePageSkeletonBlock className="tw-h-4 tw-w-11/12 tw-max-w-2xl" /><MemePageSkeletonBlock className="tw-h-4 tw-w-3/4 tw-max-w-xl" /></div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}
function _temp2(item_0) {
  return <MemePageSkeletonBlock key={item_0} className="tw-my-4 tw-h-4 tw-w-20" />;
}
function _temp(item) {
  return <div key={item}><MemePageSkeletonBlock className="tw-mb-1.5 tw-h-4 tw-w-20" /><MemePageSkeletonBlock className="tw-h-6 tw-w-24" /></div>;
}